export default {
  to: 'To:',
  transferTo: 'Transfer to',
  blindTransfer: 'Transfer',
  warmTransfer: 'Ask first',
  enterNameOrNumber: 'Enter Number',
} as const;
